// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1rpLw","title":"Info_title__3HYKI","links":"Info_links__3ikjm","link":"Info_link__1B1zQ","logo":"Info_logo__1cFet"};